var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-input"},[_c('input',{ref:"input",attrs:{"type":_vm.inputType,"placeholder":_vm.placeholder},domProps:{"value":_vm.displayValue},on:{"input":_vm.handleInput,"keydown":_vm.handleKeyDown}})])
}
var staticRenderFns = []

export { render, staticRenderFns }